import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getCropPriceSummary,
  IGetCropPriceSummaryParams,
  IGetCropPriceSummaryResponse,
} from '../../../api/crop-trends/getCropPriceSummary';

interface IUseGetCropPriceSummaryParams extends IGetCropPriceSummaryParams {
  options?: UseQueryOptions<IGetCropPriceSummaryResponse, AxiosError>;
}

export const useGetCropPriceSummary = ({ searchParam, options }: IUseGetCropPriceSummaryParams) => {
  return useQuery<IGetCropPriceSummaryResponse, AxiosError>(
    [
      'crop-price-summary',
      searchParam.wholesaleMarketCode,
      searchParam.largeCategoryCode,
      searchParam.middleCategoryCode,
      searchParam.smallCategoryCode,
    ],
    () => getCropPriceSummary({ searchParam }),
    { ...options },
  );
};
